/**
 * 通用的一些数据请求处理
 */

import {
  queryGradeApi,
  getAllGoodsTypeListApi,
  getShopGoodsTypeListApi
} from '@/api'
import { RES_OK } from '@/config'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  // 获取会员所有等级
  async getMemberGradeListAction({ getters }) {
    const {
      companyId,
      brandInfo: { id }
    } = getters
    let param = {}
    param.pageSize = -1
    param.pageIndex = 1
    param.companyId = companyId
    param.brandId = id
    // param.parentGradeId = -2
    // param.typeState = 1
    const res = await queryGradeApi(param)
    let list = []
    if (res.Code === RES_OK) {
      list = res.result || []
      list.forEach(it => (it.isCheck = false))
      // this.gradeList = list
    }
    return list
  },
  //  获取商品类型
  async getGoodsTypeListAction(context, { brandId, shopId = '' }) {
    let list = []
    let param = {}
    param.brandId = brandId
    param.shopId = shopId
    const res = await getAllGoodsTypeListApi(param)

    if (res.Code === RES_OK) {
      list = res.Result || []
      list = list.filter(it => Number(it.typeGrade) === 3)
      if (list.length) {
        list.unshift({
          name: '全部分类',
          id: ''
        })
      }
      return list
    }
  },
  async getAllShopGoodsTypeListAction(context, { brandId, shopId = '' }) {
    let list = []
    let param = {}
    param.brandId = brandId
    param.shopId = shopId
    const res = await getShopGoodsTypeListApi(param)
    if (res.Code === RES_OK) {
      list = res.Result || []
      list = list.filter(it => Number(it.typeGrade) === 3)
      if (list.length) {
        list.unshift({
          name: '全部分类',
          id: ''
        })
      }
      return list
    }
  },
  //  获取商品类型
  async getGoodsTypeListNotAllAction(context, { brandId }) {
    let list = []
    let param = {}
    param.brandId = brandId
    const res = await getAllGoodsTypeListApi(param)

    if (res.Code === RES_OK) {
      list = res.Result || []
      list = list.filter(it => Number(it.typeGrade) === 3)
      return list
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
